import React, { useEffect, useState } from "react";
import { Grid, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box } from '@mui/system';

const DEFAULT_DESIGN = "https://via.placeholder.com/400x400";
const INIT_FORM_DATE = {
	fullName: "",
	shortName: "",
	heroBanner: "",
	flagUrl: "",
	flagUrlGcp: "",
	countryBannerList: [],
};
const INIT_ERRORS = {
	fullName: "",
	shortName: "",
	heroBanner: "",
	flagUrl: "",
};
const AddMerchantModal = ({ isVisible, onClose, onCreate, existingFormData }) => {
	const theme = useTheme();

	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState(INIT_FORM_DATE);
	const [backgroundImage, setBackgroundImage] = useState(DEFAULT_DESIGN);
	const [flagImage, setFlagImage] = useState(DEFAULT_DESIGN);
	const [image, setImage] = useState(null);
	const [imageFlag, setImageFlag] = useState(null);

	useEffect(() => {
		if (existingFormData) {
			setFormData(existingFormData);
			setBackgroundImage(existingFormData.countryBannerList[0].imageUrl);
			setFlagImage(existingFormData.flagUrl);
		}
	}, [existingFormData]);

	const handleCloseModal = () => {
		setBackgroundImage(DEFAULT_DESIGN);
		setErrors(INIT_ERRORS);
		setFormData(INIT_FORM_DATE);
		onClose(false);
	};

	const validateField = (name, value) => {
		switch (name) {
			case "fullName":
				setErrors((prevState) => ({
					...prevState,
					fullName: value ? "" : "Country name is required.",
				}));
				break;
			case "shortName":
				setErrors((prevState) => ({
					...prevState,
					shortName: value ? (value.length > 2 ? "Country name must be 2 characters or less." : "") : "Country name is required.",
				}));
				break;
			case "flagUrl":
				setErrors((prevState) => ({
					...prevState,
					flagUrl: value ? (value.length > 2 ? "Country name must be 2 characters or less." : "") : "Country name is required.",
				}));
				break;
			default:
				break;
		}
	};
	const handleImageChange = (event) => {
		setErrors((prevState) => ({
			...prevState,
			heroBanner: "",
		}));

		const file = event.target.files[0];
		setImage(event.target.files[0]);
		const reader = new FileReader();
		reader.onload = () => {
			setBackgroundImage(reader.result);
		};
		if (file) {
			reader.readAsDataURL(file);
		}
	};
	const handleFlagImageChange = (event) => {
		setErrors((prevState) => ({
			...prevState,
			flagUrl: "",
		}));

		const file = event.target.files[0];
		setImageFlag(event.target.files[0]);
		const reader = new FileReader();
		reader.onload = () => {
			setFlagImage(reader.result);
		};
		if (file) {
			reader.readAsDataURL(file);
		}
	};
	const handleInputChange = (event) => {
		const { id, value } = event.target;
		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));
		validateField(id, value);
	};

	const inputProps = {
		required: true,
		fullWidth: true,
		margin: "normal",
		onChange: handleInputChange
	};

	const onCreateHandler = () => {
		const items = Object.keys(formData);
		items.forEach((item) => {
			validateField(item, formData[item]);
		});

		if (!isUpdate && !image) {
			setErrors((prevState) => ({
				...prevState,
				heroBanner: "Image is required",
			}));
		}
		if (!isUpdate && !imageFlag) {
			setErrors((prevState) => ({
				...prevState,
				image: "Image is required",
			}));
		}

		const allFieldsOk = Object.values(errors).every((x) => x === null || x === "");
		console.log({ allFieldsOk, errors });

		if (allFieldsOk) {
			onCreate({ ...formData, image, isUpdate, imageFlag });
			handleCloseModal();
		}
	};

	return (
		<Dialog open={isVisible} onClose={onClose} fullScreen={fullScreen} scroll="paper">
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Gift Country
			</DialogTitle>
			<DialogContent dividers>
				<Grid container rowSpacing={50}>
					<Grid item md={6} xs={12}>
						<img src={backgroundImage} width={"90%"} height={"90%"} alt="Gift design" loading="lazy" />
						<input type="file" name="image" accept="image/*" width={"90%"} height={"90%"} onChange={handleImageChange} />
						{errors.image && <span style={{ color: "#d32f2f" }}>{errors.image}</span>}
					</Grid>

					<Grid item md={6} xs={12}>
						<TextField {...inputProps} id="fullName" label="Full name" value={formData.fullName} error={!!errors.fullName} helperText={errors.fullName} />
						<TextField  {...inputProps} id="shortName" label="Short name" value={formData.shortName} error={!!errors.fullName} helperText={errors.shortName} />
						<Box sx={{ color: 'text.secondary' }}>Country Flag : SVG </Box>

						<img src={flagImage} width={"20%"} height={"20%"} alt="Gift design" loading="lazy" />
						<input type="file" name="image" accept="image/svg+xml" width={"90%"} height={"90%"} onChange={handleFlagImageChange} />
						{errors.image && <span style={{ color: "#d32f2f" }}>{errors.image}</span>}
					</Grid>

				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button variant="contained" onClick={onCreateHandler} disabled={!formData.fullName || !formData.shortName || (!isUpdate && !image) || (!isUpdate && !imageFlag)}>
					{isUpdate ? "Update" : "Create"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddMerchantModal;
